module.exports = __webpack_public_path__ + "images/m-interface_apple@2x-41562f.png";